<div class="card">
    <div class="card_header">
        <div class="row row_jc_space_btw">
            <div class="flex_title row">
                <p class="title fz_l fw_700">Новые лиды</p>
                <span class="separator"></span>
                <p class="subtitle fz_xs color_text_gray">Потенциальные клиенты</p>
            </div>
            <a routerLink="/customers" class="link td_underline fz_xs color_text_gray">Смотреть все</a>
        </div>
    </div>
    <div class="card_body">
        <app-skeleton *ngIf="isLoading" height="45" margin="15" [count]="5"></app-skeleton>
        <div class="no_data fz_l row row_ai_center row_jc_center color_red" *ngIf="dataMissing">{{typeof dataMissing === 'string' ? dataMissing : 'Данные отсутствуют'}}</div>
        <div class="row row_data row_jc_space_btw" *ngFor="let customer of customers">
            <div class="row">
                <div *ngIf="false" class="flex_item row channel">
                    <img src="" alt="">
                </div>
                <div class="flex_item">
                    <p class="fz_s" *ngIf="customer.firstname || customer.lastname">{{customer.firstname}} {{customer.lastname}}</p>
                    <p class="fz_s color_red" *ngIf="!customer.firstname && !customer.lastname">Без имени</p>
                    <p class="fz_xs color_text_gray">{{dateFormatterPipe.transform(customer.createdAt, 'yyyy-MM-dd HH:mm:ss')}}</p>
                </div>
            </div>
            <div class="flex_item status fz_s text_uppercase" [ngClass]="{'color_dark_green': customer.status.name === 'Новый'}">{{customer.status.name}}</div>
        </div>
    </div>
</div>